<script setup lang="ts">
import { computed } from 'vue'
import { useDocumentStore } from '@/stores/documentStore'
import { useI18n } from '@/i18n'
import { thumbnailUrl, thumbVersion } from '@/composables/useThumbnails'

const docStore = useDocumentStore()
const { t } = useI18n()
const channels = computed(() => {
  void docStore.historyVersion
  return docStore.doc?.channels ?? []
})
function thumb(pixelId: string) {
  void thumbVersion.value
  return thumbnailUrl(pixelId)
}
function rename(id: string, cur: string) {
  const n = prompt(t('layer.name'), cur)
  if (n && n !== cur) docStore.renameChannel(id, n)
}
</script>

<template>
  <div class="panel">
    <div class="panel-title row">
      <span>{{ t('panel.channels') }}</span>
      <span class="spacer" />
      <button class="icon ghost" :title="t('menu.select.saveChannel')" :disabled="!docStore.hasSelection" @click="docStore.saveSelectionAsChannel()">＋</button>
    </div>
    <div class="list">
      <div v-if="!channels.length" class="empty muted">{{ t('channels.empty') }}</div>
      <div v-for="c in channels" :key="c.id" class="ch" @dblclick="rename(c.id, c.name)">
        <span class="thumb"><img v-if="thumb(c.pixelId)" :src="thumb(c.pixelId)!" alt="" /></span>
        <span class="name">{{ c.name }}</span>
        <button class="ghost tiny" :title="t('channels.load')" @click="docStore.loadChannelAsSelection(c.id)">◌</button>
        <button class="ghost tiny" :title="t('channels.delete')" @click="docStore.removeChannel(c.id)">🗑</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.panel {
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.list {
  overflow: auto;
}
.empty {
  padding: 8px 10px;
  font-size: 11px;
}
.ch {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 3px 8px;
  border-bottom: 1px solid var(--line-weak);
}
.thumb {
  width: 30px;
  height: 22px;
  background: #000;
  border: 1px solid var(--line-strong);
  display: flex;
  overflow: hidden;
}
.thumb img {
  max-width: 100%;
  max-height: 100%;
}
.name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tiny {
  width: 22px;
  height: 20px;
  padding: 0;
}
</style>
